module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'scanner-container ' + (_vm.waitingForClose ? 'scanner-container--frozen' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanning || _vm.starting),
      expression: "scanning || starting"
    }],
    class: 'video-wrapper ' + (_vm.waitingForClose ? 'video-wrapper--frozen' : '')
  }, [_c('video', {
    ref: "video",
    staticClass: "scanner-video",
    attrs: {
      "autoplay": "",
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scanner-overlay"
  }, [_c('div', {
    class: 'scanner-area ' + (_vm.partialOk ? 'scanner-area--partial-ok' : '')
  }, [(_vm.waitingForClose) ? _c('div', {
    staticClass: "scanner-result-scanned"
  }, [_c('pre', [_vm._v(_vm._s(_vm.formattedResult))])]) : _vm._e()])])]), _vm._v(" "), (false && !_vm.error && _vm.scanning) ? _c('div', {
    class: 'scanner-loading ' + (_vm.loading ? 'scanner-loading--loading' : '')
  }, [_vm._v("\n    Scanning...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "scanner-error"
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scanner-result"
  }, [(false && _vm.scanning) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.scanRawResult) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.starting && !_vm.scanning && !_vm.error) ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        return _vm.startCamera()
      }
    }
  }, [_vm._v("Starta om skanning")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c26f5c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Scanner.vue
// module id = 946
// module chunks = 0